import axios from 'axios';
import { UAParser } from 'ua-parser-js';

const parser = new UAParser();
const result = parser.getResult();
const configureAxios = async (token) => {

	axios.defaults.baseURL = 'https://sci.prismict.com/api';

	let authToken = await localStorage.getItem('authToken')
	setAuthToken(authToken)
	return true
}


export const setAuthToken = async (token) => {

	if (token) {
		axios.defaults.headers.common['Authorization'] = token;
	} else {
		axios.defaults.headers.common['Authorization'] = '';
	}
	var clientTimezoneOffset = new Date().getTimezoneOffset() / 60;
	clientTimezoneOffset = parseInt(clientTimezoneOffset);
	if (clientTimezoneOffset > 0) {
		console.log('Positive');

		clientTimezoneOffset = "-" + Math.abs(clientTimezoneOffset)
	} else {
		console.log('Negative');
		clientTimezoneOffset = Math.abs(clientTimezoneOffset)
	}

	axios.defaults.headers.common['X-platform'] = `${result.os.name} ${result.browser.name} ${result.device.type === undefined ? "web" : result.device.type}`;
	axios.defaults.headers.common['X-Version'] = "1.0.0";
	axios.defaults.headers.common['X-timezone'] = clientTimezoneOffset;
}

export default configureAxios
